import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SuggestMealTimeRes } from '../api/openapi';
import { schedulerApi } from '../api';

interface UseSuggestMealParams {
  routineId: string;
  chatId: string;
  chatSessionId?: string;
  userId: string;
  calendarId: string;
  metricId: string;
  dateToBeSuggested: string;
  signal?: AbortSignal;
}

export const useSuggestMeal = () => {
  const queryClient = useQueryClient();
  const suggestMealMutation = useMutation({
    mutationFn: async ({
      routineId,
      chatId,
      chatSessionId,
      userId,
      calendarId,
      metricId,
      dateToBeSuggested,
      signal,
    }: UseSuggestMealParams): Promise<SuggestMealTimeRes> => {
      const response = await schedulerApi.suggestMealTime(
        {
          routineId,
          chatId,
          chatSessionId,
          userId,
          calendarId,
          metricId,
          dateToBeSuggested,
        },
        { signal }
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lifestack.calendar.events'] }); // Fetch meal calendar event blocks
    },
  });

  return {
    suggestMeal: suggestMealMutation.mutateAsync,
    ...suggestMealMutation,
  };
};
